import type { FilterDefinition, FilterType, IconName } from "@/ds";
import {
  FILTRO_CARREGANDO_MESSAGE,
  FILTRO_ERRO_MESSAGE,
  FILTRO_VAZIO_MESSAGE,
} from "./filtros-inline.constants";
import type {
  FiltroInlineCampo,
  FiltrosInlineProps,
  FiltrosInlineViewModel,
} from "./types-filtros-inline";

const TIPOS_DA_LINHA: readonly FilterType[] = ["select", "multiselect"];
const SEM_CLASSES: Readonly<Record<string, string | undefined>> = {};
const SEM_ICONES: Readonly<Record<string, IconName>> = {};
const NENHUM: readonly string[] = [];

function mensagemVazia({ isLoading, hasError }: FilterDefinition): string {
  if (isLoading) return FILTRO_CARREGANDO_MESSAGE;
  if (hasError) return FILTRO_ERRO_MESSAGE;
  return FILTRO_VAZIO_MESSAGE;
}

/** Cada campo aplica ao mudar: devolve todos os critérios com o do campo trocado, e a consulta segue no servidor. */
export function useFiltrosInline({
  definitions,
  value,
  onChange,
  testIdPrefix,
  classNames = SEM_CLASSES,
  icones = SEM_ICONES,
  obrigatorios = NENHUM,
  onLimpar,
  temFiltroAtivo = Object.values(value).some((valores) => valores.length > 0),
}: FiltrosInlineProps): FiltrosInlineViewModel {
  const trocar = (key: string, valores: string[]) => onChange({ ...value, [key]: valores });

  const campos = definitions
    .filter((definition) => TIPOS_DA_LINHA.includes(definition.type))
    .map((definition): FiltroInlineCampo => {
      const { key } = definition;
      const options = definition.options ?? [];
      const valores = value[key] ?? [];
      const valorUnico = valores[0] ?? null;

      return {
        key,
        multiplo: definition.type === "multiselect",
        placeholder: definition.label,
        options,
        valores,
        valorUnico,
        rotuloSelecionado: options.find((option) => option.value === valorUnico)?.label ?? null,
        className: classNames[key],
        icone: icones[key],
        limpavel: !obrigatorios.includes(key),
        testId: `${testIdPrefix}-filtro-${key}`,
        mensagemVazia: mensagemVazia(definition),
        buscavel: definition.searchPlaceholder !== undefined,
        searchPlaceholder: definition.searchPlaceholder,
        escolher: (valor) => trocar(key, valor ? [valor] : []),
        escolherVarios: (proximos) => trocar(key, proximos),
        limpar: () => trocar(key, []),
      };
    });

  return {
    campos,
    mostrarLimpar: onLimpar !== undefined && temFiltroAtivo,
    limpar: () => onLimpar?.(),
    limparTestId: `${testIdPrefix}-limpar-filtros`,
  };
}
